(function () {
  const modal = document.getElementById('cart-drawer-edit-modal');
  if (!modal || !window.theme || !window.theme.routes) return;

  const form = modal.querySelector('[data-cart-edit-form]');
  const optionsContainer = modal.querySelector('[data-options-container]');
  const replaceBtn = modal.querySelector('[data-replace-btn]');
  const loadingEl = modal.querySelector('[data-loading]');
  const titleEl = modal.querySelector('.cart-drawer-edit-modal__title');
  const priceEl = modal.querySelector('.cart-drawer-edit-modal__price');
  const imageEl = modal.querySelector('[data-edit-modal-image]');
  const singleHeader = modal.querySelector('[data-single-header]');
  const bundleContainer = modal.querySelector('[data-bundle-container]');

  let state = {
    itemKey: null,
    productHandle: null,
    product: null,
    selectedVariantId: null,
    isBundle: false,
    bundleRaw: null,
    bundleParts: null,
    lineQuantity: 1,
    lineItemProperties: null,
    bundleParentTitle: null
  };

  let swatchValueListCache = null;
  let swatchLiquidMap = null;

  function getSwatchSettings() {
    return (theme.settings && theme.settings) || {};
  }

  function isSwatchOption(optionName) {
    const s = getSwatchSettings();
    if (!optionName || s.swatchSource === 'none') return false;
    const optName = String(optionName).trim();
    const raw = String(s.swatchOptionName || '');
    const lowerOpt = optName.toLowerCase();
    const parts = raw.split(',').map(function (p) {
      return p.trim().toLowerCase();
    }).filter(Boolean);
    if (parts.some(function (p) {
      return p === lowerOpt;
    })) return true;
    return raw.toLowerCase().includes(lowerOpt);
  }

  function useSwatchBlocks(optionName) {
    const s = getSwatchSettings();
    if (!isSwatchOption(optionName)) return false;
    if (s.swatchSource === 'theme') {
      return s.swatchMethod === 'swatches' || s.swatchMethod === 'variant-images';
    }
    if (s.swatchSource === 'native') {
      return true;
    }
    return false;
  }

  function escapeHtml(s) {
    const div = document.createElement('div');
    div.textContent = s;
    return div.innerHTML;
  }

  function variantFeaturedSrc(variant) {
    if (!variant || !variant.featured_image) return '';
    const fi = variant.featured_image;
    return typeof fi === 'string' ? fi : fi.src || '';
  }

  function normalizeSwatchKey(s) {
    return String(s || '')
      .replace(/"/g, '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .replace(/[\u2013\u2014]/g, '-');
  }

  function getParsedSwatchValueMap() {
    if (swatchValueListCache) return swatchValueListCache;
    swatchValueListCache = Object.create(null);
    const raw = (theme.settings && theme.settings.swatchValueList) || '';
    if (!raw || typeof raw !== 'string') return swatchValueListCache;

    function putKeys(entry, namePart) {
      const k = normalizeSwatchKey(namePart);
      if (!k) return;
      swatchValueListCache[k] = entry;
      swatchValueListCache[k.replace(/\s/g, '')] = entry;
    }

    raw.split(/\r?\n/).forEach(function (line) {
      line = line.trim();
      if (!line || line.indexOf(':') === -1) return;
      const colon = line.indexOf(':');
      const namePart = line.slice(0, colon).replace(/"/g, '').trim();
      const rest = line.slice(colon + 1).trim();
      if (rest.indexOf('#') === -1) return;

      const hashParts = rest.split('#').filter(Boolean).map(function (p) {
        return p.replace(/\s.*/, '').split(/\s/)[0];
      });
      if (!hashParts.length) return;

      let entry;
      if (hashParts.length === 1 && /^[0-9A-Fa-f]{3,8}$/.test(hashParts[0])) {
        entry = { color: '#' + hashParts[0] };
      } else if (hashParts.length >= 2) {
        const cols = hashParts.map(function (h) {
          return '#' + h;
        });
        entry = {
          image: 'linear-gradient(to right, ' + cols.join(', ') + ')'
        };
      }
      if (entry) putKeys(entry, namePart);
    });
    return swatchValueListCache;
  }

  function lookupSwatchEntry(map, displayName) {
    const key = normalizeSwatchKey(displayName);
    if (!key) return null;
    if (map[key]) return map[key];
    const compact = key.replace(/\s/g, '');
    if (map[compact]) return map[compact];
    const keys = Object.keys(map).filter(function (k) {
      return map[k] && typeof map[k] === 'object';
    });
    keys.sort(function (a, b) {
      return b.length - a.length;
    });
    for (let i = 0; i < keys.length; i += 1) {
      const k = keys[i];
      if (k.length < 2) continue;
      if (key === k || key.indexOf(k) !== -1 || k.indexOf(key) !== -1) {
        return map[k];
      }
    }
    return null;
  }

  function parseProductBlockSwatchHtml(html) {
    const out = Object.create(null);
    if (!html || typeof html !== 'string') return out;
    try {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      doc.querySelectorAll('.product-block-options').forEach(function (wrap) {
        const optName = wrap.getAttribute('data-option-name');
        if (!optName) return;
        const optKey = normalizeSwatchKey(optName);
        if (!out[optKey]) out[optKey] = Object.create(null);
        wrap.querySelectorAll('.product-block-options__item').forEach(function (item) {
          const vname = item.getAttribute('data-option-item');
          if (!vname) return;
          const vk = normalizeSwatchKey(vname);
          out[optKey][vk] = {
            style: item.getAttribute('style') || '',
            dataSwatch: item.getAttribute('data-swatch') || ''
          };
        });
      });
    } catch (e) {}
    return out;
  }

  function applyLiquidProductBlockSwatch(labelEl, optionLabel, displayName) {
    if (!swatchLiquidMap) return false;
    const ok = normalizeSwatchKey(optionLabel);
    const vk = normalizeSwatchKey(displayName);
    if (!swatchLiquidMap[ok] || !swatchLiquidMap[ok][vk]) return false;
    const e = swatchLiquidMap[ok][vk];
    if (e.style && e.style.trim()) {
      labelEl.setAttribute('style', e.style);
      return true;
    }
    if (e.dataSwatch) {
      labelEl.setAttribute('data-swatch', e.dataSwatch);
      return true;
    }
    return false;
  }

  function applyNativeSwatchFromApi(labelEl, rawValue) {
    if (!rawValue || typeof rawValue !== 'object' || !rawValue.swatch) return;
    const sw = rawValue.swatch;
    let filled = false;

    if (sw.color) {
      const c = sw.color;
      if (typeof c === 'string') {
        if (c.indexOf('#') === 0) {
          labelEl.style.setProperty('--swatch-background-color', c);
          filled = true;
        } else if (c.indexOf(',') !== -1 || c.toLowerCase().indexOf('rgb') !== -1) {
          labelEl.style.setProperty('--swatch-background-color', c.indexOf('rgb') === -1 ? 'rgb(' + c + ')' : c);
          filled = true;
        }
      } else if (typeof c === 'object' && c.hex) {
        labelEl.style.setProperty('--swatch-background-color', c.hex.indexOf('#') === 0 ? c.hex : '#' + c.hex);
        filled = true;
      } else if (c.rgb !== undefined) {
        labelEl.style.setProperty('--swatch-background-color', 'rgb(' + c.rgb + ')');
        filled = true;
      } else if (c.r !== undefined && c.g !== undefined && c.b !== undefined) {
        labelEl.style.setProperty('--swatch-background-color', 'rgb(' + c.r + ',' + c.g + ',' + c.b + ')');
        filled = true;
      }
    }

    if (!filled && sw.image) {
      const u = typeof sw.image === 'string' ? sw.image : (sw.image.src || sw.image.url || '');
      if (u) {
        labelEl.style.setProperty('--swatch-background-image', 'url(' + u + ')');
        labelEl.style.setProperty('--swatch-background-size', 'cover');
      }
    }
  }

  function applySwatchStylesToLabel(labelEl, optionLabel, displayName, rawValue) {
    if (applyLiquidProductBlockSwatch(labelEl, optionLabel, displayName)) {
      if (
        labelEl.style.getPropertyValue('--swatch-background-color') ||
        labelEl.style.getPropertyValue('--swatch-background-image')
      ) {
        return;
      }
    }

    const map = getParsedSwatchValueMap();
    const entry = lookupSwatchEntry(map, displayName);
    if (entry) {
      if (entry.color) {
        labelEl.style.setProperty('--swatch-background-color', entry.color);
      }
      if (entry.image) {
        labelEl.style.setProperty('--swatch-background-image', entry.image);
      }
    }

    if (
      !labelEl.style.getPropertyValue('--swatch-background-color') &&
      !labelEl.style.getPropertyValue('--swatch-background-image')
    ) {
      applyNativeSwatchFromApi(labelEl, rawValue);
    }
  }

  function decodeHtmlEntityString(str) {
    if (!str || typeof str !== 'string') return str;
    const t = document.createElement('textarea');
    t.innerHTML = str;
    return t.value;
  }

  function parseBundleFromTrigger(trigger) {
    const raw = trigger.getAttribute('data-bundle-json');
    if (!raw) return null;
    function tryParse(s) {
      try {
        const arr = JSON.parse(s);
        return Array.isArray(arr) && arr.length ? arr : null;
      } catch (e) {
        return null;
      }
    }
    let parsed = tryParse(raw);
    if (parsed) return parsed;
    const decoded = decodeHtmlEntityString(raw);
    if (decoded && decoded !== raw) {
      parsed = tryParse(decoded);
      if (parsed) return parsed;
    }
    return null;
  }

  function parseLineItemPropertiesFromTrigger(trigger) {
    const raw = trigger.getAttribute('data-line-properties-json');
    if (!raw) return null;
    try {
      const o = JSON.parse(raw);
      return o && typeof o === 'object' ? o : null;
    } catch (e) {
      return null;
    }
  }


  function variantIdForCartApi(v) {
    const s = String(v == null ? '' : v).trim();
    if (!s) return null;
    if (/^\d+$/.test(s) && s.length > 15) return s;
    const n = parseInt(s, 10);
    return Number.isNaN(n) ? s : n;
  }

  function replaceIdInString(str, oldId, newId) {
    if (typeof str !== 'string' || oldId === newId) return str;
    try {
      return str.replace(new RegExp('\\b' + oldId.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\b', 'g'), newId);
    } catch (e) {
      return str.split(oldId).join(newId);
    }
  }

  function buildFlyBundleProperties(baseProps, bundleRaw, bundleParts) {
    const out = Object.create(null);
    if (baseProps && typeof baseProps === 'object') {
      Object.keys(baseProps).forEach(function (k) {
        out[k] = baseProps[k];
      });
    }
    if (!bundleRaw || !bundleParts || !bundleRaw.length) return out;
    for (let i = 0; i < bundleRaw.length; i += 1) {
      const oldId = String(bundleRaw[i].variantId);
      const part = bundleParts[i];
      if (!part || part.selectedVariantId == null) continue;
      const newId = String(part.selectedVariantId);
      if (oldId === newId) continue;
      Object.keys(out).forEach(function (k) {
        const val = out[k];
        if (String(val) === oldId) {
          out[k] = newId;
        } else if (typeof val === 'string' && val.indexOf(oldId) !== -1) {
          out[k] = replaceIdInString(val, oldId, newId);
        }
      });
    }
    return out;
  }

  function findPropertyKeyInsensitive(props, nameEn) {
    const want = String(nameEn).toLowerCase();
    const keys = Object.keys(props || {});
    for (let i = 0; i < keys.length; i++) {
      if (String(keys[i]).toLowerCase() === want) return keys[i];
    }
    return null;
  }

  function findItemsPropertyKey(baseProps) {
    if (!baseProps || typeof baseProps !== 'object') return 'Items';
    const k = findPropertyKeyInsensitive(baseProps, 'Items');
    if (k) return k;
    const keys = Object.keys(baseProps);
    for (let i = 0; i < keys.length; i++) {
      const v = baseProps[keys[i]];
      if (typeof v === 'string' && /\d+\s*x\s/i.test(v)) return keys[i];
    }
    return 'Items';
  }
  function parseItemsPropertyTitles(itemsStr) {
    if (!itemsStr || typeof itemsStr !== 'string') return [];
    return itemsStr
      .split(',')
      .map(function (s) {
        return s.trim();
      })
      .map(function (part) {
        const m = part.match(/^\d+\s*x\s*(.+)$/i);
        return m ? m[1].trim() : part;
      })
      .filter(Boolean);
  }

  function normalizeBundleTitleForMatch(s) {
    return String(s || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
  }

  /**
   * 弹窗内子商品顺序与购物车 Items 行一致（如 "1 x A, 1 x B"）。
   */
  function orderBundleComponentsByItemsLine(bundle, lineProps) {
    if (!bundle || !Array.isArray(bundle) || !bundle.length) return bundle;
    const base = lineProps && typeof lineProps === 'object' ? lineProps : {};
    const itemsKey = findItemsPropertyKey(base) || findPropertyKeyInsensitive(base, 'Items');
    const itemsStr = itemsKey ? base[itemsKey] : null;
    const order = parseItemsPropertyTitles(typeof itemsStr === 'string' ? itemsStr : '');
    if (!order.length) return bundle;

    const used = new Array(bundle.length).fill(false);
    const result = [];
    order.forEach(function (wantTitle) {
      const w = normalizeBundleTitleForMatch(wantTitle);
      for (let i = 0; i < bundle.length; i++) {
        if (used[i]) continue;
        const t = normalizeBundleTitleForMatch(bundle[i] && bundle[i].title);
        if (t === w) {
          result.push(bundle[i]);
          used[i] = true;
          return;
        }
      }
    });
    for (let i = 0; i < bundle.length; i++) {
      if (!used[i]) result.push(bundle[i]);
    }
    return result.length === bundle.length ? result : bundle;
  }
  function buildBundleItemsPropertyString(bundleParts, lineQty) {
    const q = lineQty || 1;
    return bundleParts
      .map(function (p) {
        let title = '';
        if (p.product && p.product.title) {
          title = String(p.product.title).trim();
        } else if (state.bundleRaw && state.bundleRaw[p.index] && state.bundleRaw[p.index].title) {
          title = String(state.bundleRaw[p.index].title).trim();
        }
        if (!title) return '';
        return q + ' x ' + title;
      })
      .filter(Boolean)
      .join(', ');
  }

  function mergeBundleDisplayProperties(merged, bundleParts, parentTitle, lineQty, originalLineProps) {
    const base = originalLineProps && typeof originalLineProps === 'object' ? originalLineProps : {};
    const out = merged && typeof merged === 'object' ? Object.assign({}, merged) : {};
    const itemsLine = buildBundleItemsPropertyString(bundleParts, lineQty);
    if (itemsLine) {
      const itemsKey = findItemsPropertyKey(base) || findPropertyKeyInsensitive(out, 'Items') || 'Items';
      out[itemsKey] = itemsLine;
    }
    if (parentTitle) {
      const bundleKey = findPropertyKeyInsensitive(base, 'Bundle') || findPropertyKeyInsensitive(out, 'Bundle') || 'Bundle';
      out[bundleKey] = parentTitle;
    }
    return out;
  }
  function ensureAbsoluteImageUrl(url) {
    if (!url || typeof url !== 'string') return '';
    const u = url.trim();
    if (u.indexOf('//') === 0 || /^https?:/i.test(u)) return u;
    const root =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root.replace(/\/$/, '')
        : '';
    if (!root) return u;
    return root + (u.charAt(0) === '/' ? u : '/' + u);
  }
  /**
   * Replace 后 Shopify 可能不返回 item_components，父行写入 bundle_edit_json，
   * 供 Liquid 生成 data-bundle-json，再次编辑时仍能加载套装内子商品。
   */
  function buildBundleComponentsJsonString(bundleParts) {
    const arr = bundleParts.map(function (p) {
      const raw = state.bundleRaw && state.bundleRaw[p.index] ? state.bundleRaw[p.index] : null;
      const pr = p.product;
      const handle = (pr && pr.handle) || (raw && raw.handle) || '';
      const title = (pr && pr.title) || (raw && raw.title) || '';
      const vid = p.selectedVariantId;
      let price = raw && raw.price != null ? raw.price : 0;
      let image = '';
      const options = [];
      if (pr) {
        const v = (pr.variants || []).find(function (x) {
          return String(x.id) === String(vid);
        });
        if (v) {
          if (v.price != null) price = v.price;
          image = variantFeaturedSrc(v);
          if (pr.options && pr.options.length) {
            pr.options.forEach(function (optName, idx) {
              const name =
                typeof optName === 'string'
                  ? optName
                  : optName && optName.name
                    ? optName.name
                    : '';
              if (v.options && v.options[idx] != null) {
                options.push({ name: name, value: String(v.options[idx]) });
              }
            });
          }
        }
      }
      if (!image && raw && raw.image) image = raw.image;
      image = ensureAbsoluteImageUrl(image);
      return {
        title: title,
        handle: handle,
        variantId: vid,
        price: price,
        image: image,
        options: options
      };
    });
    return JSON.stringify(arr);
  }

    /**
   * Replace 时仅保留父套装行：
   * - 显示属性：Items + Bundle
   * - 隐藏属性：bundle_edit_json（供再次编辑恢复子商品）
   * 不再向购物车新增 parent_id 子行。
   */
  function buildBundleCartItems(parentVariantId, quantity, bundleParts, lineProps) {
    const pid = variantIdForCartApi(parentVariantId);
    const parentItem = {
      id: pid,
      quantity: quantity
    };

    const merged = mergeBundleDisplayProperties(
      {},
      bundleParts,
      state.bundleParentTitle,
      quantity,
      lineProps
    );

    // 保留套装内部结构，供下次打开编辑弹窗使用
    merged.bundle_edit_json = buildBundleComponentsJsonString(bundleParts);

    if (merged && Object.keys(merged).length > 0) {
      parentItem.properties = merged;
    }

    // 仅返回父行，不添加子商品行
    return [parentItem];
  }

  function updateBundleRowPrice(product, variantId, el) {
    if (!el) return;
    const v = (product.variants || []).find(function (x) {
      return String(x.id) === String(variantId);
    });
    if (v) {
      el.textContent = formatPriceWithDollar(v.price)
    }
  }

  function updateBundleRowImage(product, variantId, el) {
    if (!el) return;
    const v = (product.variants || []).find(function (x) {
      return String(x.id) === String(variantId);
    });
    let src = variantFeaturedSrc(v);
    if (!src && product.featured_image) {
      src = typeof product.featured_image === 'string' ? product.featured_image : product.featured_image.src || '';
    }
    if (src) {
      el.src = src;
      el.hidden = false;
      el.alt = product.title || '';
    }
  }

  function findVariantFromOptionSelection(product, containerEl) {
    if (!product || !containerEl) return null;
    const fieldsets = containerEl.querySelectorAll('.option-selector');
    const selected = [];
    fieldsets.forEach(function (fs) {
      const checked = fs.querySelector('.opt-btn:checked');
      selected.push(checked ? String(checked.value) : '');
    });
    if (selected.some(function (s) {
      return !s;
    })) return null;

    function matches(v) {
      if (!v || !v.options || v.options.length !== selected.length) return false;
      for (let i = 0; i < selected.length; i += 1) {
        if (String(v.options[i]).toLowerCase() !== String(selected[i]).toLowerCase()) return false;
      }
      return true;
    }

    let v = (product.variants || []).find(function (x) {
      return matches(x) && x.available;
    });
    if (!v) v = (product.variants || []).find(matches);
    return v || null;
  }
  function formatPriceWithDollar(cents) {
    const raw = theme.formatMoney
      ? String(theme.formatMoney(cents))
      : (Number(cents || 0) / 100).toFixed(2);

    const trimmed = raw.trim();
    return trimmed.startsWith('$') ? trimmed : `$${trimmed}`;
  }
  function renderBundleRows(components) {
    if (!bundleContainer) return;
    bundleContainer.innerHTML = '';
    state.bundleParts = [];
    components.forEach(function (comp, i) {
      const row = document.createElement('div');
      row.className = 'cart-drawer-edit-modal__bundle-block';

      const header = document.createElement('div');
      header.className = 'cart-drawer-edit-modal__header cart-drawer-edit-modal__bundle-row';

      const media = document.createElement('div');
      media.className = 'cart-drawer-edit-modal__media';
      const img = document.createElement('img');
      img.className = 'cart-drawer-edit-modal__image theme-img';
      img.width = 100;
      img.height = 100;
      img.loading = 'lazy';
      if (comp.image) {
        img.src = comp.image;
        img.alt = comp.title || '';
        img.hidden = false;
      } else {
        img.hidden = true;
      }
      media.appendChild(img);

      const heading = document.createElement('div');
      heading.className = 'cart-drawer-edit-modal__heading-text';
      const h3 = document.createElement('h3');
      h3.className = 'cart-drawer-edit-modal__title h4';
      h3.textContent = comp.title || '';
      const p = document.createElement('p');
      p.className = 'cart-drawer-edit-modal__price theme-money';
      p.textContent = formatPriceWithDollar(comp.price);
      heading.appendChild(h3);
      heading.appendChild(p);

      header.appendChild(media);
      header.appendChild(heading);

      const optionsMount = document.createElement('div');
      optionsMount.className = 'cart-drawer-edit-modal__bundle-comp-options product-column-right';

      const part = {
        index: i,
        handle: comp.handle,
        selectedVariantId: comp.variantId,
        priceEl: p,
        imgEl: img,
        optionsMount: optionsMount,
        product: null
      };
      state.bundleParts.push(part);

      row.appendChild(header);
      row.appendChild(optionsMount);
      bundleContainer.appendChild(row);
    });
    bundleContainer.hidden = false;
  }

  function setBundleMode(on) {
    state.isBundle = on;
    if (!on) {
      state.bundleRaw = null;
      state.bundleParts = null;
      state.bundleParentTitle = null;
    }
    if (singleHeader) singleHeader.hidden = on;
    if (bundleContainer) {
      if (!on) {
        bundleContainer.hidden = true;
        bundleContainer.innerHTML = '';
      }
    }
  }

  function updateModalImage(product) {
    if (state.isBundle) return;
    if (!imageEl) return;
    const v = (product.variants || []).find(function (x) {
      return String(x.id) === String(state.selectedVariantId);
    });
    let src = '';
    if (v) src = variantFeaturedSrc(v);
    if (!src && product.featured_image) {
      src = typeof product.featured_image === 'string' ? product.featured_image : product.featured_image.src || '';
    }
    if (src) {
      imageEl.src = src;
      imageEl.hidden = false;
      imageEl.alt = product.title || '';
    }
  }

  function openModal(trigger) {
    state.itemKey = trigger.dataset.itemKey;
    state.productHandle = trigger.dataset.productHandle;
    state.selectedVariantId = trigger.dataset.variantId;
    state.lineQuantity = parseInt(trigger.dataset.quantity, 10) || 1;
    state.lineItemProperties = parseLineItemPropertiesFromTrigger(trigger);

const bundle = parseBundleFromTrigger(trigger);
  const bundleOrdered = bundle ? orderBundleComponentsByItemsLine(bundle, state.lineItemProperties) : null;
  setBundleMode(!!bundleOrdered);
  if (bundleOrdered) {
    state.bundleRaw = bundleOrdered;
      state.bundleParentTitle = (trigger.dataset.productTitle || '').trim();
      if (titleEl) titleEl.textContent = '';
      if (priceEl) priceEl.textContent = '';
      if (imageEl) {
        imageEl.removeAttribute('src');
        imageEl.hidden = true;
      }
    } else {
      state.bundleRaw = null;
      state.bundleParentTitle = null;
      const title = trigger.dataset.productTitle || '';
      const price = trigger.dataset.productPrice || '';
      if (titleEl) titleEl.textContent = title;
      if (priceEl) priceEl.textContent = formatPriceWithDollar(price);
      if (imageEl) {
        const initialImg = trigger.dataset.productImage || '';
        if (initialImg) {
          imageEl.src = initialImg;
          imageEl.hidden = false;
          imageEl.alt = title;
        } else {
          imageEl.removeAttribute('src');
          imageEl.hidden = true;
        }
      }
    }

    form.setAttribute('hidden', '');
    if (loadingEl) loadingEl.hidden = false;
    optionsContainer.innerHTML = '';

    modal.open(trigger);
    loadProduct();
  }

  function loadBundleProducts(components) {
    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root.replace(/\/$/, '') : '';
    const tasks = components.map(function (comp) {
      if (!comp.handle) {
        return Promise.resolve([null, '']);
      }
      const h = encodeURIComponent(comp.handle);
      return Promise.all([
        fetch(root + '/products/' + h + '.js').then(function (res) {
          return res.json();
        }),
        fetch(root + '/products/' + h + '?view=recent-card')
          .then(function (res) {
            return res.ok ? res.text() : '';
          })
          .catch(function () {
            return '';
          })
      ]);
    });

    Promise.all(tasks)
      .then(function (results) {
        results.forEach(function (pair, i) {
          const product = pair[0];
          const htmlFrag = pair[1] || '';
          const part = state.bundleParts && state.bundleParts[i];
          if (!part || !part.optionsMount) return;
          if (!product) {
            part.optionsMount.innerHTML = '<p class="small-text">Unable to load product.</p>';
            return;
          }
          part.product = product;
          swatchLiquidMap = parseProductBlockSwatchHtml(htmlFrag);
          let vid = part.selectedVariantId;
          const hasOpts = product.options && product.options.length > 0;
          if (!hasOpts) {
            const v0 = product.variants && product.variants[0];
            if (v0) part.selectedVariantId = v0.id;
            return;
          }
          renderOptionsInto(product, part.optionsMount, vid, {
            idPrefix: 'bc-' + i,
            priceEl: part.priceEl,
            imageEl: part.imgEl,
            onVariantChange: function (newVid) {
              part.selectedVariantId = newVid;
            }
          });
        });
        if (loadingEl) loadingEl.hidden = true;
        form.removeAttribute('hidden');
      })
      .catch(function () {
        if (loadingEl) loadingEl.hidden = true;
        form.removeAttribute('hidden');
        optionsContainer.innerHTML = '<p class="small-text">Unable to load product options.</p>';
      });
  }

  function loadProduct() {
    if (state.isBundle) {
      optionsContainer.innerHTML = '';
      state.product = null;
      swatchLiquidMap = null;
      if (!state.bundleRaw || !state.bundleRaw.length) {
        if (loadingEl) loadingEl.hidden = true;
        form.removeAttribute('hidden');
        return;
      }
      renderBundleRows(state.bundleRaw);
      loadBundleProducts(state.bundleRaw);
      return;
    }

    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root.replace(/\/$/, '') : '';
    const handle = encodeURIComponent(state.productHandle);
    const urlJson = root + '/products/' + handle + '.js';
    const urlBlock = root + '/products/' + handle + '?view=recent-card';

    swatchLiquidMap = null;

    Promise.all([
      fetch(urlJson).then(function (res) {
        return res.json();
      }),
      fetch(urlBlock)
        .then(function (res) {
          return res.ok ? res.text() : '';
        })
        .catch(function () {
          return '';
        })
    ])
      .then(function (results) {
        const product = results[0];
        const htmlFrag = results[1] || '';
        swatchLiquidMap = parseProductBlockSwatchHtml(htmlFrag);
        state.product = product;
        renderOptions(product);
        if (loadingEl) loadingEl.hidden = true;
        form.removeAttribute('hidden');
        updateModalImage(product);
      })
      .catch(function () {
        if (loadingEl) loadingEl.hidden = true;
        form.removeAttribute('hidden');
        if (!state.isBundle) {
          optionsContainer.innerHTML = '<p class="small-text">Unable to load product options.</p>';
        }
      });
  }

  function buildSwatchLabel(name, id, rawValue, optionLabel) {
    const labelEl = document.createElement('label');
    labelEl.htmlFor = id;
    labelEl.className = 'opt-label opt-label--swatch btn relative text-center';

    const s = getSwatchSettings();
    const listed = s.swatchStyle === 'listed';

    labelEl.setAttribute('data-swatch', normalizeSwatchKey(name));
    applySwatchStylesToLabel(labelEl, optionLabel, name, rawValue);

    const span = document.createElement('span');
    span.className = (listed ? '' : 'visually-hidden ') + 'js-value';
    span.textContent = name;
    labelEl.appendChild(span);

    return labelEl;
  }

  function buildBtnLabel(name, id) {
    const labelEl = document.createElement('label');
    labelEl.htmlFor = id;
    labelEl.className = 'opt-label opt-label--btn btn';
    labelEl.textContent = name;
    return labelEl;
  }

  function updateOptionAvailabilityInContainer(product, containerEl) {
    if (!product || !Array.isArray(product.variants) || !containerEl) return;

    const fieldsets = containerEl.querySelectorAll('.option-selector');
    if (!fieldsets.length) return;

    const selectedOptions = [];
    fieldsets.forEach(function (fs, index) {
      const checked = fs.querySelector('.opt-btn:is(:checked)');
      selectedOptions[index] = checked ? checked.value : null;
    });

    fieldsets.forEach(function (fieldset, optionIndex) {
      const inputs = fieldset.querySelectorAll('.opt-btn');

      inputs.forEach(function (input) {
        const value = input.value;
        const label = fieldset.querySelector('label[for="' + CSS.escape(input.id) + '"]');

        input.disabled = false;
        input.classList.remove('is-unavailable');
        if (label) label.classList.remove('is-unavailable');

        const hasAvailableVariant = product.variants.some(function (variant) {
          if (!variant.available) return false;
          for (let i = 0; i < variant.options.length; i += 1) {
            const variantValue = String(variant.options[i]).toLowerCase();
            if (i === optionIndex) {
              if (variantValue !== String(value).toLowerCase()) return false;
            } else {
              const selected = selectedOptions[i];
              if (selected && variantValue !== String(selected).toLowerCase()) return false;
            }
          }
          return true;
        });

        if (!hasAvailableVariant) {
          input.disabled = true;
          input.classList.add('is-unavailable');
          if (label) label.classList.add('is-unavailable');
        }
      });
    });
  }

  function renderOptionsInto(product, containerEl, selectedVariantId, opts) {
    const idPrefix = opts.idPrefix || 'cart-edit';
    const priceRowEl = opts.priceEl;
    const imageRowEl = opts.imageEl;
    const onVariantChange = opts.onVariantChange || function () {};

    containerEl.innerHTML = '';

    const selectedVariant =
      (product.variants || []).find(function (v) {
        return String(v.id) === String(selectedVariantId);
      }) || null;

    if (!product.options || product.options.length === 0) {
      const v = product.variants && product.variants[0];
      if (v) onVariantChange(v.id, product);
      return;
    }

    product.options.forEach(function (optionName, index) {
      const fieldset = document.createElement('fieldset');
      fieldset.className = 'option-selector';
      fieldset.setAttribute('data-index', String(index + 1));
      fieldset.setAttribute('data-option', typeof optionName === 'string' ? optionName : optionName && optionName.name ? optionName.name : '');

      const label =
        typeof optionName === 'string'
          ? optionName
          : optionName && optionName.name
            ? optionName.name
            : '';

      const swatchMode = useSwatchBlocks(label);
      const legendHtml = '<legend class="label">' + escapeHtml(label) + '</legend>';
      fieldset.innerHTML = legendHtml + '<div class="option-selector__btns flex flex-wrap"></div>';

      const values = product.options_with_values
        ? product.options_with_values[index] && product.options_with_values[index].values
        : [];
      const valuesList = values.length
        ? values
        : (product.variants || [])
            .map(function (v) {
              return v.options[index];
            })
            .filter(function (v, i, a) {
              return a.indexOf(v) === i;
            });

      valuesList.forEach(function (valueName) {
        const name =
          typeof valueName === 'string'
            ? valueName
            : valueName && valueName.name
              ? valueName.name
              : String(valueName);

        const hasAvailableForValue = (product.variants || []).some(function (v) {
          return (
            String(v.options[index]).toLowerCase() === String(name).toLowerCase() &&
            v.available
          );
        });

        const variantForValue =
          (product.variants || []).find(function (v) {
            return (
              String(v.options[index]).toLowerCase() === String(name).toLowerCase() &&
              v.available
            );
          }) ||
          (product.variants || []).find(function (v) {
            return String(v.options[index]).toLowerCase() === String(name).toLowerCase();
          }) ||
          null;

        const id = idPrefix + '-opt-' + index + '-' + escapeHtml(name).replace(/\s/g, '-');
        const input = document.createElement('input');
        input.type = 'radio';
        input.name = 'option-' + idPrefix + '-' + index;
        input.value = name;
        input.id = id;
        input.classList.add('opt-btn', 'visually-hidden', 'js-option');

        if (!hasAvailableForValue) {
          input.classList.add('is-unavailable');
          input.disabled = true;
        }

        if (
          selectedVariant &&
          String(selectedVariant.options[index]).toLowerCase() === String(name).toLowerCase()
        ) {
          input.checked = true;
        }

        input.dataset.variantId = variantForValue ? variantForValue.id : '';

        let labelEl;
        if (swatchMode) {
          labelEl = buildSwatchLabel(name, id, valueName, label);
        } else {
          labelEl = buildBtnLabel(name, id);
        }

        if (!hasAvailableForValue) {
          labelEl.classList.add('is-unavailable');
        }

        const btns = fieldset.querySelector('.option-selector__btns');
        btns.appendChild(input);
        btns.appendChild(labelEl);

        input.addEventListener('change', function () {
          const resolved = findVariantFromOptionSelection(product, containerEl);
          let vid = null;
          if (resolved && resolved.id != null) {
            vid = resolved.id;
          } else if (input.dataset.variantId) {
            vid = parseInt(input.dataset.variantId, 10);
          }
          onVariantChange(vid, product);
          if (priceRowEl || imageRowEl) {
            if (priceRowEl) updateBundleRowPrice(product, vid, priceRowEl);
            if (imageRowEl) updateBundleRowImage(product, vid, imageRowEl);
          } else {
            state.selectedVariantId = vid;
            updatePrice(product);
            updateModalImage(product);
          }
          updateOptionAvailabilityInContainer(product, containerEl);
        });
      });

      containerEl.appendChild(fieldset);
    });

    const resolvedInit = findVariantFromOptionSelection(product, containerEl);
    const curVid =
      resolvedInit && resolvedInit.id != null
        ? resolvedInit.id
        : selectedVariant && selectedVariant.id != null
          ? selectedVariant.id
          : selectedVariantId;

    if (priceRowEl || imageRowEl) {
      if (priceRowEl) updateBundleRowPrice(product, curVid, priceRowEl);
      if (imageRowEl) updateBundleRowImage(product, curVid, imageRowEl);
    } else {
      state.selectedVariantId = curVid;
      updatePrice(product);
      updateModalImage(product);
    }
    updateOptionAvailabilityInContainer(product, containerEl);
  }

  function renderOptions(product) {
    optionsContainer.innerHTML = '';
    const selectedVariant =
      (product.variants || []).find(function (v) {
        return String(v.id) === String(state.selectedVariantId);
      }) || null;

    if (!product.options || product.options.length === 0) {
      const v = product.variants && product.variants[0];
      if (v) state.selectedVariantId = v.id;
      return;
    }

    renderOptionsInto(product, optionsContainer, state.selectedVariantId, {
      idPrefix: 'cart-edit',
      onVariantChange: function (variantId) {
        state.selectedVariantId = variantId;
      }
    });
  }

  function updatePrice(product) {
    const v = (product.variants || []).find(function (v) {
      return String(v.id) === String(state.selectedVariantId);
    });
    if (v && priceEl) {
      priceEl.textContent = priceEl.textContent = formatPriceWithDollar(v.price);
    }
  }
  function getCartSectionsPayload() {
    const sectionsToUpdate = ['page-header', 'cart-drawer']
      .map(function (sel) {
        return document.querySelector(sel);
      })
      .filter(Boolean);
    const sections = sectionsToUpdate
      .map(function (el) {
        return el.dataset.sectionId;
      })
      .join(',');
    return { sectionsToUpdate: sectionsToUpdate, sections: sections };
  }

  function applyCartSectionsResponse(data, sectionsToUpdate) {
    if (!data || !data.sections || !sectionsToUpdate || !sectionsToUpdate.length) return false;
    let applied = 0;
    sectionsToUpdate.forEach(function (el) {
      const sid = el.dataset.sectionId;
      const html = data.sections[sid];
      if (typeof html === 'string' && html.length) {
        el.updateFromCartChange(html);
        applied += 1;
      }
    });
    return applied > 0;
  }
  modal.addEventListener('click', function (e) {
    if (
      e.target !== modal &&
      !e.target.matches('.js-close-modal') &&
      !e.target.closest('.js-close-modal')
    ) {
      return;
    }
    modal.close();
  });

  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('.cart-drawer-edit-trigger');
    if (!trigger || !trigger.closest('.cart-drawer')) return;
    e.preventDefault();
    openModal(trigger);
  });

  replaceBtn.addEventListener('click', function () {
    const quantity = state.lineQuantity || 1;
    replaceBtn.disabled = true;

    const cartSections = getCartSectionsPayload();

    if (state.isBundle && state.bundleParts && state.bundleParts.length) {
      const parentVariantId = state.selectedVariantId;
      if (
        !parentVariantId ||
        state.bundleParts.some(function (p) {
          return !p.selectedVariantId;
        })
      ) {
        replaceBtn.disabled = false;
        return;
      }

      const items = buildBundleCartItems(parentVariantId, quantity, state.bundleParts, state.lineItemProperties);

      const updatePayload = { updates: {} };
      updatePayload.updates[state.itemKey] = 0;
      fetch(theme.routes.cartUpdate, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(updatePayload)
      })
        .then(function (res) {
          return res.json();
        })
        .then(function () {
          const body = {
            items: items,
            sections: cartSections.sections,
            sections_url: window.location.pathname
          };
          return fetch(theme.routes.cartAdd, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(body)
          });
        })
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          if (data.status && data.status !== 200) {
            throw new Error(data.description || data.message);
          }
          if (!applyCartSectionsResponse(data, cartSections.sectionsToUpdate)) {
            document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
          }
          modal.close();
        })
        .catch(function (err) {
          console.error('Cart edit error', err);
          replaceBtn.disabled = false;
        })
        .finally(function () {
          replaceBtn.disabled = false;
        });
      return;
    }

    const variantId = state.selectedVariantId;
    if (!variantId) {
      replaceBtn.disabled = false;
      return;
    }

    const updatePayload = { updates: {} };
    updatePayload.updates[state.itemKey] = 0;
    fetch(theme.routes.cartUpdate, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(updatePayload)
    })
      .then(function (res) {
        return res.json();
      })
      .then(function () {
        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', quantity);
        if (cartSections.sections) {
          formData.append('sections', cartSections.sections);
          formData.append('sections_url', window.location.pathname);
        }
        return fetch(theme.routes.cartAdd, {
          method: 'POST',
          body: formData,
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }
        });
      })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (data.status && data.status !== 200) {
          throw new Error(data.description || data.message);
        }
        if (!applyCartSectionsResponse(data, cartSections.sectionsToUpdate)) {
          document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
        }
        modal.close();
      })
      .catch(function (err) {
        console.error('Cart edit error', err);
        replaceBtn.disabled = false;
      })
      .finally(function () {
        replaceBtn.disabled = false;
      });
  });
})();
